/**
 * People who are on the property and do not work here, and are not guests.
 *
 * One of them. Grant Whitfield is from the ownership group. He is not staff,
 * not crew and not a gate: he has no department on the ladder, no price, and
 * nothing of his can be asked for, traded for or taken. What he has is eyes,
 * like anybody, and a tablet.
 *
 * `collects` is his reaction shape, and it is the one shape that is not a
 * consequence. Everybody else who has seen enough of something does something
 * about it; he writes it down on a tablet nobody else reads, and nothing lands
 * on your card, your standing or anybody's opinion. What he has on you is read
 * later from what the building already keeps (`sim/story.js`).
 *
 * `greets` is a list rather than a ladder, because a ladder is a relationship
 * and he does not have one with you. He calls everybody team. He never learns
 * a name.
 *
 * He is only on the property while the story says he is touring: from the
 * middle of the third act, a few days a week, ten until half three. His
 * meetings are at four, and where he has them is `data/story.js`.
 */

/** Post eyes: a man looking round a building he is thinking of changing. */
const TOUR_EYES = { range: 26, halfAngle: 55, dwell: 1.2 };

export const VISITORS = [
  {
    id: 'owner-grant',
    name: 'Grant Whitfield',
    /** How he looks, the same every time: `world/appearance.js`. */
    look: { hair: 'slick', hairColour: 'silver', face: null, skin: 1, glasses: true, build: { height: 1.05, shoulders: 1.05, chest: 1.02 } },
    affiliation: 'Ownership',
    department: 'ownership',
    visitor: true,
    collects: true,
    /*
     * The front of the property and the room the section works in, and nowhere
     * a guest would not be walked: the lobby, the grand entrance, and a long
     * look at the ballroom from its north side and its east side. Dwells are
     * seconds, so game minutes.
     */
    route: [
      [150, 42, 20],
      [115, 37, 0],
      [98, 37, 0],
      [56, 22, 25],
      [92, 22, 0],
      [94, 70, 20],
      [94, 37, 0],
      [115, 37, 0],
    ],
    speed: 1.3,
    window: { from: '10:00', to: '16:10' },
    vision: TOUR_EYES,
    greets: [
      'Morning, team. Do not mind me. Just looking.',
      'Great energy in here, team. Love to see it.',
      'Carry on, team. Pretend I am not here.',
      'Big room. Lot of labour in a room like this, team.',
    ],
    charm: {
      cold: 'Busy day. You know how it is.',
      warm: 'We are all on the same side here, right?',
      ok: 'Of course. Team first.',
      no: 'Sure. I will make a note of that.',
    },
    line: 'Just getting a feel for the place, team.',
  },
];

export const VISITORS_BY_ID = Object.fromEntries(VISITORS.map((person) => [person.id, person]));

export default VISITORS;
